<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs6 md4
            v-for="item in items"
            :key="item.id">
            <v-card>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">
                    {{ item.name || $t('unnamed') }}
                  </h3>
                </div>
              </v-card-title>
              <v-card-text>
                {{ $t('visuals.scheme') }} # {{ item.id }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text icon @click="routeToVisual(item.id, 'watch')" data-test="show-visual">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <!--
                <v-btn text icon @click="routeToVisual(item.id, 'command')">
                  <v-icon>settings_remote</v-icon>
                </v-btn>
                <v-btn text icon @click="routeToVisual(item.id, 'edit')">
                  <v-icon>edit</v-icon>
                </v-btn>
                -->
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex v-if="$can('admin')">
            <v-card>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">
                    {{ $t('visuals.new') }}
                  </h3>
                </div>
              </v-card-title>
              <v-card-text>
                {{ $t('feel-free-to-start-creating') }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text icon @click="createNewVisual" data-test="create">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemsHelpers from '../helpers/items-helpers.es6'

export default {
  mixins: [displayHelpers, itemsHelpers],
  data () {
    return {
      model: {
        name: 'visuals'
      }
    }
  },
  methods: {
    routeToVisual (id, initVisualMode) {
      this.$router.push({ name: 'visuals/id', params: { id: id, initVisualMode: initVisualMode } })
    },
    async createNewVisual () {
      try {
        await this.$store.dispatch('updateItem', { modelName: this.model.name, item: { id: null } })
        await this.storeUpdate()
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
